<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: PingFang SC, PingFang SC-Regular, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;

}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  word-wrap: break-word;
  border-radius: 0;

  &:focus {
    outline: none;
  }
}


.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.pointer {
  cursor: pointer;
}
</style>
